// extracted by mini-css-extract-plugin
export default {"heading":"TesterTermsOfServicePage_heading__bgMpW","content":"TesterTermsOfServicePage_content__d+DEh","privacyTabs":"TesterTermsOfServicePage_privacyTabs__xY0kp"};